// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import ArrowBackward from "@store/Components/Toolkit/Icons/ArrowBackward";
import ArrowForward from "@store/Components/Toolkit/Icons/ArrowForward";
import Bell from "@store/Components/Toolkit/Icons/Bell/BellFill";
import Bookmark from "@store/Components/Toolkit/Icons/Bookmark/BookmarkFill";
import Calendar from "@store/Components/Toolkit/Icons/Calendar/CalendarFill";
import Car from "@store/Components/Toolkit/Icons/Car/CarFill";
import ChevronLeft from "@store/Components/Toolkit/Icons/ChevronLeft";
import ChevronRight from "@store/Components/Toolkit/Icons/ChevronRight";
import Clock from "@store/Components/Toolkit/Icons/Clock/ClockFill";
import Copy from "@store/Components/Toolkit/Icons/Copy/CopyFill";
import Download from "@store/Components/Toolkit/Icons/Download";
import Edit from "@store/Components/Toolkit/Icons/Edit/EditFill";
import Email from "@store/Components/Toolkit/Icons/Email/EmailFill";
import Export from "@store/Components/Toolkit/Icons/Export";
import ExternalLink from "@store/Components/Toolkit/Icons/ExternalLink";
import Eye from "@store/Components/Toolkit/Icons/Eye/EyeFill";
import Globe from "@store/Components/Toolkit/Icons/Globe/GlobeFill";
import Heart from "@store/Components/Toolkit/Icons/Heart/HeartFill";
import Import from "@store/Components/Toolkit/Icons/Import";
import Navigation2 from "@store/Components/Toolkit/Icons/Navigation2/Navigation2Fill";
import Options2 from "@store/Components/Toolkit/Icons/Options2/Options2Fill";
import PersonAdd from "@store/Components/Toolkit/Icons/PersonAdd/PersonAddFill";
import Pin from "@store/Components/Toolkit/Icons/Pin/PinFill";
import PlusCircle from "@store/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import Save from "@store/Components/Toolkit/Icons/Save/SaveFill";
import Search from "@store/Components/Toolkit/Icons/Search";
import Settings from "@store/Components/Toolkit/Icons/Settings/SettingsFill";
import ShoppingCart from "@store/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
import Tag from "@store/Components/Toolkit/Icons/Tag/TagLine";
import Trash from "@store/Components/Toolkit/Icons/Trash/TrashFill";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@store/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type IconOption = DataOption<IconPresentationProps["src"]>;
export interface IconOptionMapper {
    none: IconOption;
    arrowForward: IconOption;
    arrowBackward: IconOption;
    chevronRight: IconOption;
    chevronLeft: IconOption;
}
export type IconOptions = DataOptions<IconOption> & IconOptionMapper;
export type Icon = LiteralUnion<keyof IconOptionMapper>;

export const iconOptions: IconOptions = {
    none: { id: "none", displayName: "None", value: "", isDefault: true },
    arrowForward: { id: "arrowForward", displayName: "Arrow Forward", value: ArrowForward },
    arrowBackward: { id: "arrowBackward", displayName: "Arrow Backward", value: ArrowBackward },
    bell: { id: "bell", displayName: "Bell", value: Bell },
    bookmark: { id: "bookmark", displayName: "Bookmark", value: Bookmark },
    calendar: { id: "calendar", displayName: "Calendar", value: Calendar },
    cart: { id: "cart", displayName: "Cart", value: ShoppingCart },
    chevronRight: { id: "chevronRight", displayName: "Chevron Right", value: ChevronRight },
    chevronLeft: { id: "chevronLeft", displayName: "Chevron Left", value: ChevronLeft },
    clock: { id: "clock", displayName: "Clock", value: Clock },
    cog: { id: "cog", displayName: "Cog", value: Settings },
    copy: { id: "copy", displayName: "Copy", value: Copy },
    download: { id: "download", displayName: "Download", value: Download },
    email: { id: "email", displayName: "Email", value: Email },
    export: { id: "export", displayName: "Export", value: Export },
    external: { id: "external", displayName: "External", value: ExternalLink },
    eye: { id: "eye", displayName: "Eye", value: Eye },
    globe: { id: "globe", displayName: "Globe", value: Globe },
    heart: { id: "heart", displayName: "Heart", value: Heart },
    import: { id: "import", displayName: "Import", value: Import },
    navigation: { id: "navigation", displayName: "Navigation", value: Navigation2 },
    options: { id: "options", displayName: "Options", value: Options2 },
    pencil: { id: "pencil", displayName: "Pencil", value: Edit },
    pin: { id: "pin", displayName: "Pin", value: Pin },
    plusCircle: { id: "plusCircle", displayName: "Plus (Circled)", value: PlusCircle },
    save: { id: "save", displayName: "Save", value: Save },
    search: { id: "search", displayName: "Search", value: Search },
    shipping: { id: "shipping", displayName: "Shipping", value: Car },
    tag: { id: "tag", displayName: "Tag", value: Tag },
    trash: { id: "trash", displayName: "Trash Bin", value: Trash },
    userPlus: { id: "userPlus", displayName: "User Plus", value: PersonAdd },
};

export type IconFieldValue = Icon | undefined;
export interface IconFieldOptions {
    isChildDefinition?: boolean;
    displayName?: string;
}

export const getIconFieldData = (value: IconFieldValue, options?: IconFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(iconOptions, value);
};

export const getIconFieldDefinition = (name: string, options?: IconFieldOptions) => {
    const { isChildDefinition, displayName = "Icon" } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(iconOptions),
        name,
        displayName,
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getIconField = (name: string, options?: IconFieldOptions) => {
    const parse = (value: IconFieldValue) => getIconFieldData(value, options);

    return {
        definition: getIconFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getIconField;
